module.exports = __webpack_public_path__ + "static/media/wechat.01a2218d.png";